import type { WingmanBffKind } from "./bff";

// The BFF enforces this over setup AND the response stream. The browser's
// fetch timeout ends at headers and Wingman's SDK budget starts after setup.
export const WINGMAN_GENERATION_TIMEOUT_MS = 10 * 60 * 1000;

export const WINGMAN_GENERATION_MIN_TOKEN_LIFETIME_SECONDS =
  WINGMAN_GENERATION_TIMEOUT_MS / 1000 + 2 * 60;

export function startsWingmanGeneration(
  kind: WingmanBffKind,
  method: string,
  path: readonly string[],
): boolean {
  return method === "POST" &&
    path.length === 3 &&
    path[0] === "conversations" &&
    path[2] === (kind === "v2" ? "generate" : "messages");
}
